<div class="col-lg-12 col-md-12 col-12">
    <div class="bk-title--default text-center mb--70">
         <h6 class="heading heading-h6 theme-color"><br><br><br></h6>
         <div class="bkseparator--30"></div>
         <h3 class="heading heading-h3">Activador Akashico® Luz Ilimitada<sup>®</sup> Facilitador </h3>
     </div>
     <div class="row">
        
        <!-- Start Single Testimonial -->
         <div class="col-lg-4 col-md-4 col-sm-12 col-12">
             <div class="testimonial testimonial_style--1">
                 <div class="content">
                    <div class="testimonial-info">
                         <div class="post-thumbnail">
                             <img src="assets/img/directorio/9611529128.jpg" alt="foto del estudiante">
                         </div>
                         
                     </div>
                     <p class="bk_pra"><br>
                     <li>Lucrecia Matuz Colmenares</li>
                     <li>lck.2904.matuz@gmail.com</li>
                     <li>Tel. 961-152 91 28</li>
                     <li>Tuxtla Gutiérrez, Chiapas </li>
                     <li>México</li>
                     </p>
                     
                     <div class="testimonial-quote">
                         <span class="fa fa-quote-right"></span>
                     </div>
                 </div>
             </div>
         </div>
         <!-- End Single Testimonial -->
         
          <!-- Start Single Testimonial -->
         <div class="col-lg-4 col-md-4 col-sm-12 col-12">
             <div class="testimonial testimonial_style--1">
                 <div class="content">
                    <div class="testimonial-info">
                         <div class="post-thumbnail">
                             <img src="assets/img/directorio/9612527752.jpg" alt="foto del estudiante">
                         </div>
                         
                     </div>
                     <p class="bk_pra"><br>
                     <li>Susana Cruz Constancio</li>
                     <li>susyconst@hotmail.com</li>
                     <li>Tel. 9612527752</li>
                     <li>Tuxtla Gutiérrez, Chiapas </li>
                     <li>México</li>
                     </p>
                     
                     <div class="testimonial-quote">
                         <span class="fa fa-quote-right"></span>
                     </div>
                 </div>
             </div>
         </div>
         <!-- End Single Testimonial -->
         
            <!-- Start Single Testimonial -->
         <div class="col-lg-4 col-md-4 col-sm-12 col-12">
             <div class="testimonial testimonial_style--1">
                 <div class="content">
                    <div class="testimonial-info">
                         <div class="post-thumbnail">
                             <img src="assets/img/directorio/9621529296.jpg" alt="foto del estudiante">
                         </div>
                         
                     </div>
                     <p class="bk_pra"><br>
                     <li>María de los Ángeles Ramos Moreno</li>
                     <li>angeles.ramos@hotmail.com</li>
                     <li>Tel. 962 152 92 96 </li>
                     <li>Tapachula, Chiapas </li>
                     <li>México</li>
                     </p>
                     
                     <div class="testimonial-quote">
                         <span class="fa fa-quote-right"></span>
                     </div>
                 </div>
             </div>
         </div>
         <!-- End Single Testimonial -->
         
              <!-- Start Single Testimonial -->
         <div class="col-lg-4 col-md-4 col-sm-12 col-12">
             <div class="testimonial testimonial_style--1">
                 <div class="content">
                    <div class="testimonial-info">
                         <div class="post-thumbnail">
                             <img src="assets/img/directorio/9621225959.jpg" alt="foto del estudiante">
                         </div>
                         
                     </div>
                     <p class="bk_pra"><br>
                     <li>Griselda de Jesús Sánchez Crisóstomo</li>
                     <li>grisel073@hotmail.com</li>
                     <li>Tel. 9621225959 </li>
                     <li>Tapachula, Chiapas </li>
                     <li>México</li>
                     </p>
                     
                     <div class="testimonial-quote">
                         <span class="fa fa-quote-right"></span>
                     </div>
                 </div>
             </div>
         </div>
         <!-- End Single Testimonial -->
         
                <!-- Start Single Testimonial -->
         <div class="col-lg-4 col-md-4 col-sm-12 col-12">
             <div class="testimonial testimonial_style--1">
                 <div class="content">
                    <div class="testimonial-info">
                         <div class="post-thumbnail">
                             <img src="assets/img/directorio/9621050410.jpg" alt="foto del estudiante">
                         </div>
                         
                     </div>
                     <p class="bk_pra"><br>
                     <li>María Isabel Gamboa García</li>
                     <li>marissagamb@hotmail.com</li>
                     <li>Tel. 9621050410 </li>
                     <li>Tapachula, Chiapas </li>
                     <li>México</li>
                     </p>
                     
                     <div class="testimonial-quote">
                         <span class="fa fa-quote-right"></span>
                     </div>
                 </div>
             </div>
         </div>
         <!-- End Single Testimonial -->
         
           
         
          <!-- Start Single Testimonial -->
         <div class="col-lg-4 col-md-4 col-sm-12 col-12">
             <div class="testimonial testimonial_style--1">
                 <div class="content">
                    <div class="testimonial-info">
                         <div class="post-thumbnail">
                             <img src="assets/img/directorio/9196864589.jpg" alt="foto del estudiante">
                         </div>
                         
                     </div>
                     <p class="bk_pra"><br>
                     <li>Jorge Nemesio Vázquez Aguilar</li>
                     <li>vagujorge@outlook.com</li>
                     <li>Tel. 9196864589 </li>
                     <li>Ocosingo, Chiapas </li>
                     <li>México</li>
                     </p>
                     
                     <div class="testimonial-quote">
                         <span class="fa fa-quote-right"></span>
                     </div>
                 </div>
             </div>
         </div>
         <!-- End Single Testimonial -->
         
            <!-- Start Single Testimonial -->
         <div class="col-lg-4 col-md-4 col-sm-12 col-12">
             <div class="testimonial testimonial_style--1">
                 <div class="content">
                    <div class="testimonial-info">
                         <div class="post-thumbnail">
                             <img src="assets/img/directorio/9612384323.jpg" alt="foto del estudiante">
                         </div>
                         
                     </div>
                     <p class="bk_pra"><br>
                     <li>Marcial Montejo López</li>
                     <li>marcialmontejolopez@hotmail.com</li>
                     <li>Tel. 961 238 43 23 </li>
                     <li>Tuxtla Gutiérrez, Chiapas </li>
                     <li>México</li>
                     </p>
                     
                     <div class="testimonial-quote">
                         <span class="fa fa-quote-right"></span>
                     </div>
                 </div>
             </div>
         </div>
         <!-- End Single Testimonial -->    
         
         <!-- Start Single Testimonial -->
         <div class="col-lg-4 col-md-4 col-sm-12 col-12">
             <div class="testimonial testimonial_style--1">
                 <div class="content">
                    <div class="testimonial-info">
                         <div class="post-thumbnail">
                             <img src="assets/img/directorio/2224697786.jpg" alt="foto del estudiante">
                         </div>
                         
                     </div>
                     <p class="bk_pra"><br>
                     <li>María de la Luz Guarneros Contreras</li>
                     <li>luzguarneros@hotmail.com</li>
                     <li>Tel. 2224697786 </li>
                     <li>Puebla, Puebla </li>
                     <li>México</li>
                     </p>
                     
                     <div class="testimonial-quote">
                         <span class="fa fa-quote-right"></span>
                     </div>
                 </div>
             </div>
         </div>
         <!-- End Single Testimonial -->
         
           <!-- Start Single Testimonial -->
         <div class="col-lg-4 col-md-4 col-sm-12 col-12">
             <div class="testimonial testimonial_style--1">
                 <div class="content">
                    <div class="testimonial-info">
                         <div class="post-thumbnail">
                             <img src="assets/img/directorio/2228648592.jpg" alt="foto del estudiante">
                         </div>
                         
                     </div>
                     <p class="bk_pra"><br>
                     <li>José Luciano García Nolasco </li>
                     <li>jlucianog100@hotmail.com</li>
                     <li>Tel. 22 28 64 85 92 </li>
                     <li>Puebla, Puebla </li>
                     <li>México</li>
                     </p>
                     
                     <div class="testimonial-quote">
                         <span class="fa fa-quote-right"></span>
                     </div>
                 </div>
             </div>
         </div>
         <!-- End Single Testimonial -->
         
           <!-- Start Single Testimonial -->
         <div class="col-lg-4 col-md-4 col-sm-12 col-12">
             <div class="testimonial testimonial_style--1">
                 <div class="content">
                    <div class="testimonial-info">
                         <div class="post-thumbnail">
                             <img src="assets/img/directorio/2228648592.jpg" alt="foto del estudiante">
                         </div>
                         
                     </div>
                     <p class="bk_pra"><br>
                     <li>Gloria Lizbeth Peñaloza Mejia </li>
                     <li>g.lizbeth_pmejia@hotmail.com</li>
                     <li>Tel. 6641730088 </li>
                     <li>Cancún, Quintana Roo </li>
                     <li>México</li>
                     </p>
                     
                     <div class="testimonial-quote">
                         <span class="fa fa-quote-right"></span>
                     </div>
                 </div>
             </div>
         </div>
         <!-- End Single Testimonial -->
         
            <!-- Start Single Testimonial -->
         <div class="col-lg-4 col-md-4 col-sm-12 col-12">
             <div class="testimonial testimonial_style--1">
                 <div class="content">
                    <div class="testimonial-info">
                         <div class="post-thumbnail">
                             <img src="assets/img/directorio/9984249406.jpg" alt="foto del estudiante">
                         </div>
                         
                     </div>
                     <p class="bk_pra"><br>
                     <li>Vania Atenea Gasque Medina </li>
                     <li>ateneavania@gmail.com</li>
                     <li>Tel. 9984249406| </li>
                     <li>Cancún, Quintana Roo </li>
                     <li>México</li>
                     </p>
                     
                     <div class="testimonial-quote">
                         <span class="fa fa-quote-right"></span>
                     </div>
                 </div>
             </div>
         </div>
         <!-- End Single Testimonial -->
         
         
         
         
         

       
     </div>
 </div>